const airlines = [
    { "value": "AA", "label": "American Airlines (AA)" },
    { "value": "AF", "label": "Air France (AF)" },
    { "value": "AI", "label": "Air India (AI)" },
    { "value": "AK", "label": "AirAsia (AK)" },
    { "value": "AM", "label": "Aeromexico (AM)" },
    { "value": "AR", "label": "Aerolíneas Argentinas (AR)" },
    { "value": "AS", "label": "Alaska Airlines (AS)" },
    { "value": "AT", "label": "Royal Air Maroc (AT)" },
    { "value": "AV", "label": "Avianca (AV)" },
    { "value": "AY", "label": "Finnair (AY)" },
    { "value": "AZ", "label": "ITA Airways (AZ)" },
    { "value": "BA", "label": "British Airways (BA)" },
    { "value": "B6", "label": "JetBlue Airways (B6)" },
    { "value": "BR", "label": "EVA Air (BR)" },
    { "value": "CA", "label": "Air China (CA)" },
    { "value": "CI", "label": "China Airlines (CI)" },
    { "value": "CM", "label": "Copa Airlines (CM)" },
    { "value": "CX", "label": "Cathay Pacific (CX)" },
    { "value": "CZ", "label": "China Southern Airlines (CZ)" },
    { "value": "DE", "label": "Condor (DE)" },
    { "value": "DL", "label": "Delta Air Lines (DL)" },
    { "value": "EK", "label": "Emirates (EK)" },
    { "value": "ET", "label": "Ethiopian Airlines (ET)" },
    { "value": "EY", "label": "Etihad Airways (EY)" },
    { "value": "FJ", "label": "Fiji Airways (FJ)" },
    { "value": "FR", "label": "Ryanair (FR)" },
    { "value": "GA", "label": "Garuda Indonesia (GA)" },
    { "value": "GF", "label": "Gulf Air (GF)" },
    { "value": "G3", "label": "Gol Linhas Aéreas (G3)" },
    { "value": "HA", "label": "Hawaiian Airlines (HA)" },
    { "value": "HU", "label": "Hainan Airlines (HU)" },
    { "value": "IB", "label": "Iberia (IB)" },
    { "value": "IG", "label": "Air Italy (IG)" },
    { "value": "JL", "label": "Japan Airlines (JL)" },
    { "value": "JQ", "label": "Jetstar Airways (JQ)" },
    { "value": "JU", "label": "Air Serbia (JU)" },
    { "value": "KE", "label": "Korean Air (KE)" },
    { "value": "KL", "label": "KLM Royal Dutch Airlines (KL)" },
    { "value": "KM", "label": "Air Malta (KM)" },
    { "value": "KP", "label": "ASKY Airlines (KP)" },
    { "value": "KQ", "label": "Kenya Airways (KQ)" },
    { "value": "KU", "label": "Kuwait Airways (KU)" },
    { "value": "LA", "label": "LATAM Airlines (LA)" },
    { "value": "LG", "label": "Luxair (LG)" },
    { "value": "LH", "label": "Lufthansa (LH)" },
    { "value": "LO", "label": "LOT Polish Airlines (LO)" },
    { "value": "LS", "label": "Jet2.com (LS)" },
    { "value": "LX", "label": "SWISS (LX)" },
    { "value": "LY", "label": "El Al Israel Airlines (LY)" },
    { "value": "MF", "label": "XiamenAir (MF)" },
    { "value": "MH", "label": "Malaysia Airlines (MH)" },
    { "value": "MK", "label": "Air Mauritius (MK)" },
    { "value": "MS", "label": "EgyptAir (MS)" },
    { "value": "MU", "label": "China Eastern Airlines (MU)" },
    { "value": "NH", "label": "ANA All Nippon Airways (NH)" },
    { "value": "NZ", "label": "Air New Zealand (NZ)" },
    { "value": "OK", "label": "Czech Airlines (OK)" },
    { "value": "OM", "label": "MIAT Mongolian Airlines (OM)" },
    { "value": "OS", "label": "Austrian Airlines (OS)" },
    { "value": "OU", "label": "Croatia Airlines (OU)" },
    { "value": "OZ", "label": "Asiana Airlines (OZ)" },
    { "value": "PC", "label": "Pegasus Airlines (PC)" },
    { "value": "PG", "label": "Bangkok Airways (PG)" },
    { "value": "PR", "label": "Philippine Airlines (PR)" },
    { "value": "PS", "label": "Ukraine International Airlines (PS)" },
    { "value": "QF", "label": "Qantas (QF)" },
    { "value": "QR", "label": "Qatar Airways (QR)" },
    { "value": "RJ", "label": "Royal Jordanian (RJ)" },
    { "value": "RO", "label": "TAROM (RO)" },
    { "value": "S7", "label": "S7 Airlines (S7)" },
    { "value": "SA", "label": "South African Airways (SA)" },
    { "value": "SK", "label": "Scandinavian Airlines (SK)" },
    { "value": "SN", "label": "Brussels Airlines (SN)" },
    { "value": "SQ", "label": "Singapore Airlines (SQ)" },
    { "value": "SU", "label": "Aeroflot (SU)" },
    { "value": "SV", "label": "Saudia (SV)" },
    { "value": "SY", "label": "Sun Country Airlines (SY)" },
    { "value": "TG", "label": "Thai Airways (TG)" },
    { "value": "TK", "label": "Turkish Airlines (TK)" },
    { "value": "TP", "label": "TAP Air Portugal (TP)" },
    { "value": "TU", "label": "Tunisair (TU)" },
    { "value": "U2", "label": "easyJet (U2)" },
    { "value": "UA", "label": "United Airlines (UA)" },
    { "value": "UK", "label": "Vistara (UK)" },
    { "value": "UL", "label": "SriLankan Airlines (UL)" },
    { "value": "UX", "label": "Air Europa (UX)" },
    { "value": "VA", "label": "Virgin Australia (VA)" },
    { "value": "VB", "label": "VivaAerobús (VB)" },
    { "value": "VH", "label": "Viva Air Colombia (VH)" },
    { "value": "VN", "label": "Vietnam Airlines (VN)" },
    { "value": "VS", "label": "Virgin Atlantic (VS)" },
    { "value": "VY", "label": "Vueling (VY)" },
    { "value": "W6", "label": "Wizz Air (W6)" },
    { "value": "WS", "label": "WestJet (WS)" },
    { "value": "X3", "label": "Tuifly (X3)" },
    { "value": "XY", "label": "Flynas (XY)" }
  ]
  

export default airlines;